<template>
  <div>
    <iHeader
      backType="blank"
      :backEvent="true"
      @back-event="closeWebview()"
      :back="true"
      svgColor="'#13161B"
    >
    <div slot="headText">
        <span class="head-txt">
          用车平台
        </span>
    </div>
  </iHeader>
    <div class="contentBox">
      <NoData
        v-if="infoItem && infoItem.length < 1"
      ></NoData>
      <ul v-else>
        <li @click="goOrderList(item)" v-for="(item,index) in infoItem" :key="index">
          <Svgs
            :color="'var(--themeColor)'"
            :classes="item.Channel==1?'caricon':'caricon'"
            name="iconwangyueche2"
          />
          <div class="centerInfro">
            <h3>{{item.Txt}}</h3>
             <span>未审批订单</span>
          </div>
          <div class="rightInfor">
            <p>{{ item.Count || 0 }}<span>单</span></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infoItem: [],
    };
  },
  created() {
    this.redirectRouteListeners(); //记录全局路由轨迹
    this.$root.$eventHub.$on("closeWebview", (data) => {
      this.closeWebview();
    });
    this.GetProposalOrderCount();
  },
  methods: {
    async GetProposalOrderCount() {
      let params = {
        IsByCategory:true
      };
      if (this.SmartStorage.get("proposalId")) {
        params.Filter = {
          ProcessId: this.SmartStorage.get("proposalId"),
        };
        params.isAuthorized =
        this.SmartStorage.get("eventData").isFromMore
          ? true
          : false;
      }else{
        params.IsByMice=false;
      }
      let _this=this;
      this.services.dsm_StatByStatus(params).then(function (res) {
        if (res.success) {
          _this.infoItem = res.content;
        }
      });
    },
    /**
     * Channel:
     * 1、网约车
     * 2、地方车
     */
    goOrderList(data) {
      this.$router.push({
        path: "/approvalList",
        query: {
          IsOnline: data.Channel==1?true:false,
        },
      });
    },
    redirectRouteListeners() {
      this.SmartStorage.set("routeListeners", ["closeWebview"]);
    },
    // 退出城市车队页面
    closeWebview() {
      this.SmartStorage.get("isH5")
        ? this._h5Back()
        : this.closeAppWithReload();
    },
  },
};
</script>

<style lang="sass">
@import '@/assets/approval/approvalIndex.scss'
</style>